import { Fragment, ReactNode } from "react";
import logo from "../../images/logo/mascote.png";

type Props = {
  children?: ReactNode;
  className?: string;
};

const HomeLogo = ({ children, className = "" }: Props) => {
  return (
    <Fragment>
      <div
        className={`${className}`}
        style={{
          zIndex: 0,
        }}
      >
        <img src={logo} alt="" className="w-52" />
      </div>
    </Fragment>
  );
};

export default HomeLogo;
